import * as yup from 'yup';

const validationSchema = yup.object({
    fatherName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .min(3, 'Please enter a valid name')
      .max(50, 'Please enter a valid name')
      .required('Please specify the Father name as per Aadhar'),

      motherName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .min(3, 'Please enter a valid name')
      .max(50, 'Please enter a valid name')
      .required('Please specify the Mother name as per Aadhar'),

      phone: yup
      .string()
      .trim()
      .required('Please enter phone number')
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*|[ -])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/),

     phone1: yup
      .string()
      .trim()
      .required('Please enter phone number')
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*|[ -])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/),

  email: yup
      .string()
      .trim()
      .email('Please enter a valid email address')
      .required('Email is required.'),

    email1: yup
      .string()
      .trim()
      .email('Please enter a valid email address')
      .required('Email is required.'),

     resadd: yup
      .string()
      .required('Please specify your address')
      .min(5, 'Please enter a valid address')
      .max(200, 'Please enter a valid address'),

    resadd1: yup
      .string()
      .required('Please specify your address')
      .min(5, 'Please enter a valid address')
      .max(200, 'Please enter a valid address'),
    
    area: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your Area')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter area'),

    area1: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your Area')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter area'),

    dist: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your District')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter district'),

    dist1: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your District')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter district'),

    state: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your state')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter a valid address'),

    state1: yup
      .string()
      .matches(/^[a-zA-Z ]{2,40}$/)
      .required('Please specify your state')
      .min(2, 'Please enter a valid address')
      .max(200, 'Please enter a valid address'), 

    pin: yup
      .string()
      .matches(/-?\d*.?\d{1,2}/)
      .required('Please specify correct pincode')
      .min(6, 'The number should be minimum of 6')
      .max(7, 'The number should be maximum of 7'),

    pin1: yup
      .string()
      .matches(/-?\d*.?\d{1,2}/)
      .required('Please specify correct pincode')
      .min(6, 'The number should be minimum of 6')
      .max(7, 'The number should be maximum of 7'),

    offnum: yup
      .string()
      .trim()
      .matches(
        /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)$/,
        'Please enter a valid phone number.',
      ),

    offnum1: yup
      .string()
      .trim()
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*|[ -])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
        'Please enter a valid phone number.',
      ), 
   
    resnum: yup
      .string()
      .trim()
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*|[ -])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
        'Please enter a valid phone number.',
      ),

    resnum1: yup
    .string()
      .trim()
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*|[ -])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
        'Please enter a valid phone number.',
      ), 
 
    gross: yup
      .string()
      .matches(/-?\d*.?\d{1,2}/)
      .required('Please specify your income'),

    gross1: yup
      .string()
      .matches(/-?\d*.?\d{1,2}/)
      .required('Please specify your income'),
   
  });

  export default validationSchema;
